import { useEffect } from 'react';

const STYLE_ID = 'bt-crisp-hide';

/**
 * Hides the Crisp chat widget while `hidden` is true (a page whose bottom corner is
 * taken, e.g. Team Inbox, or the agent workspace's split view). A plain
 * `display: none` — never a transform on Crisp's container, which would turn its
 * fixed parts' off-screen helper into page overflow (scrollbars).
 */
export function useHideCrisp(hidden = true): void {
  useEffect(() => {
    if (!hidden) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = '#crisp-chatbox, .crisp-client { display: none !important; visibility: hidden !important; }';
    document.head.appendChild(style);
    return () => style.remove();
  }, [hidden]);
}
